import { render, staticRenderFns } from "./ListarTributacao.vue?vue&type=template&id=6a1120e7&scoped=true"
import script from "./ListarTributacao.vue?vue&type=script&lang=js"
export * from "./ListarTributacao.vue?vue&type=script&lang=js"
import style0 from "./ListarTributacao.vue?vue&type=style&index=0&id=6a1120e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1120e7",
  null
  
)

export default component.exports